export default __webpack_public_path__ + "static/media/BrainBreak cards70.9b4a0b64.png";